// src/features/dashboard/services/appListApi.ts

import api
from '../../../api/apiService';

import {
  ENDPOINTS,
} from '../../../api/endpoints';

import type {

  AppListApiResponse,

  AppListRequest,

} from '../types/appList.types';

/**
 * =========================================
 * GET APP LIST
 * =========================================
 */
export const getAppList =
  async (
    payload:
      AppListRequest,
  ):
    Promise<
      AppListApiResponse[]
    > => {

    const response =
      await api.post(
        ENDPOINTS.TOP_APPLICATIONS,
        payload,
      );

    return response.data;
  };